import * as React from 'react';

import AdminPageHeaderBffProvider from 'bundles/composable-page-header-admin/providers/AdminPageHeaderBffProvider';
import AdminSelectedPartnerSlugProvider from 'bundles/composable-page-header-admin/providers/AdminSelectedPartnerSlugProvider';

const DefaultDegreePageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <AdminPageHeaderBffProvider>
      <AdminSelectedPartnerSlugProvider>{children}</AdminSelectedPartnerSlugProvider>
    </AdminPageHeaderBffProvider>
  );
};

export default DefaultDegreePageHeaderProvider;
